import type { GpuTrainingResults, GpuAiResult, GpuAiResponse } from "~/types/gpu";

export type GpuCalculationStrategy = (
  input: string
) => Promise<GpuTrainingResults | GpuAiResult[]>;

export type ApiCalculationResult = {
  results: GpuAiResult[]
  response: GpuAiResponse
}

export const createLocalCalculationStrategy = (): GpuCalculationStrategy => {
    const { calculateGpuTraining } = useGpuCalculation();
    return async (input: string): Promise<GpuTrainingResults> => {
        return await calculateGpuTraining(input);
  };
};

// AI API 計算策略 - 調用新 API (返回完整 response)
export const fetchGpuAiQuery = async (input: string): Promise<GpuAiResponse> => {
  const response = await $fetch<GpuAiResponse>("/api/gpu-ai-query", {
    method: "POST",
    body: { input_text: input },
  });
  return response;
};

// 向後相容的 AI API 計算策略 - 只返回 gpuResults
export const createApiCalculationStrategy = (): GpuCalculationStrategy => {
  return async (input: string): Promise<GpuAiResult[]> => {
    const response = await fetchGpuAiQuery(input);
    return response.gpuResults || [];
  };
};
